<!-- eslint-disable max-len -->
<template>
  <transition name="fade">
  <modal ref="modalito" name="conditions" :styles="{ top: '24px !important' }" :minHeight="Infinity"
    :classes="'modal-terms'"  height="auto" adaptive :maxWidth="800" width="100%">
    <div style="position: relative; height: 100%;">
      <div class="modal-header">
        <h1 class="header-title">Condições Gerais do Seguro de Pessoas Coletivo Prestamista Saldo Devedor</h1>
        <a class="header-close" href="#!" @click="$modal.hide('conditions')">
          <XIcon style="color: #0f172a" />
        </a>
      </div>
      <div :style="{ width: `${modalWidth - 15}px` }" class="backdrop-parent">
        <div v-show="isLoading" :style="{ width: `${modalWidth - 24}px` }" class="backdrop">
          <div ref="progress-bar" class="progress-bar">
            <div ref="bar" :style="{ width: ((barWidth > 100) ? 100 : barWidth)+'%' }" class="bar"></div>
          </div>
          <span class="loading-text">Carregando {{ `${(barWidth > 100) ? 100 : barWidth }%` }}</span>
        </div>
      </div>
      <div style="position: relative; height: 100%;">
        <vue-pdf-embed class="pdf" :width="`${modalWidth - 24}`" :scale="1"
          :style="{  visibility: isLoading ? 'hidden' : 'visible', zIndex: 1 }" @rendered="setLoading" :source="pdfURL" />
      </div>
        <a target="_blank"
        :style="downloadButtonStyle"
          href="https://s3.amazonaws.com/cdn.parcelex.com.br/assets/v3/institucional/CC%2B-%2B15414.901073_2014-30%2B-%2Bv20230424.pdf"
          class="loadingButton">
          <DownloadIcon style="color: #278DB3" />Baixar condições gerais
        </a>
    </div>
  </modal>
</transition>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import { XIcon, DownloadIcon } from '@vue-hero-icons/outline';
import onboardingServiceV2 from '@/feature/onboarding-v2/onboardingV2.service';
import onboardingService from '../onboarding.service';

export default {
  name: 'conditions-modal',
  components: {
    XIcon,
    DownloadIcon,
    VuePdfEmbed,
  },
  data: () => ({
    isLoading: true,
    barWidth: 1,
    isMounted: false,
    modalWidth: '100',
    gambi: false,
    pdfURL: '',
    interval: null,
  }),
  computed: {
    isOnboardingVersionV2() {
      return this.$router.currentRoute.name === 'v2-onboarding-insurance';
    },
    downloadButtonStyle() {
      return { width: `${this.modalWidth - 40}px`, position: 'fixed' };
    },
  },
  mounted() {
    window.addEventListener('resize', this.windowResized);
    this.windowResized();
    const service = this.isOnboardingVersionV2 ? onboardingServiceV2 : onboardingService;
    service.downloadPDFFromS3('CC+-+15414.901073_2014-30+-+v20230424.pdf').then((response) => {
      this.pdfURL = URL.createObjectURL(response.data);
    });
  },
  methods: {
    windowResized() {
      if (this.$refs.modalito?.trueModalWidth) {
        const child = this.$refs.modalito.trueModalWidth;
        this.modalWidth = child;
      }
    },
    showTermsModal() {
      this.$modal.show('terms');
    },
    showTermsConditions() {
      clearInterval(this.interval);
      this.barWidth = 0;
      this.isLoading = true;
      let count = 0;
      const self = this;
      this.interval = setInterval(() => {
        count += 10;
        if (self.barWidth === 100) {
          clearInterval(this.interval);
        }
        self.barWidth = count;
      }, 100);

      setTimeout(() => {
        this.barWidth = 100;
        clearInterval(this.interval);
      }, 3000);
      this.$modal.show('conditions');
      this.$refs.modalito.visible = false;
      setTimeout(() => {
        this.$refs.modalito.visible = true;
      }, 100);
    },
    setLoading() {
      this.isLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0.3;
}

::v-deep .vm--modal {
  top: 24px !important;
  border-top-left-radius: 24px !important;
  border-top-right-radius: 24px !important;
  overflow: visible !important;
  height: 100% !important;
}

::v-deep .vm--container {
  min-height: auto !important;
}

::v-deep .pdf::-webkit-scrollbar {
  display: none;
}

.modal-header {
  display: flex;
  position: sticky;
  top: 0;
  padding: 16px 20px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-bottom: 1px solid #e2e8f0;
  z-index: 9999;

  >.header-title {
    color: #0f172a;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }

  >.header-close {
    display: flex;
    margin-left: auto;
    align-items: center
  }
}

.pdf {
  display: flex;
  flex-direction: column;
  gap: 12px;
  scroll-behavior: smooth;
  top: 0px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  bottom: 0;
  position: absolute;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 12px;
  background: #E2E8F0;
}

.backdrop-parent {
  position: fixed;
  top: 120px;
  bottom: 93px;

  @media (min-width: 381px) {
    top: 105px;
  }

  @media (min-width: 663px) {
    top: 81px;
  }

}

.backdrop {
  background: #E2E8F0;
  display: flex;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: -moz-available; /* WebKit-based browsers will ignore this. */
  min-height: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
  min-height: stretch;
  gap: 12px;

  .loading-text {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    color: #64748B;
  }
}

.progress-bar {
  max-width: 150px;
  width: 100%;
  background: #CBD5E1;
  height: 8px;
  border-radius: 4px;

  >.bar {
    width: 1%;
    height: 8px;
    border-radius: 4px;
    background: #94A3B8;
  }
}

.loadingButton {
  display: flex;
  bottom: 0;
  padding: 20px 20px 34px 20px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: calc(100% - 25px);
  background: white;
  z-index: 999;
  justify-content: center;
  border-top: 1px solid #E2E8F0;
  text-decoration: none;
  font-weight: 400;
  line-height: 24px;
  color: #278DB3;
}

.modal-footer {
  display: flex;
  bottom: 0;
  padding: 20px 20px 34px 20px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: calc(100% - 40px);
  background: white;
  z-index: 999;
  justify-content: center;
  border-top: 1px solid #E2E8F0;

  .link {
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
    font-weight: 400;
    line-height: 24px;
    color: #278DB3;
  }
}
</style>
